import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";

import apiClient from "../../../api-client";

export const useUpdateBookletProfileSetupMutation = getWrappedUseMutation(apiClient.ItineraryBookletsProfileSetup.put);
